'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // import Autosuggest from 'react-autosuggest'

// import * as searchActions from 'redux/modules/search'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Loader from 'react-loader'

var Styles = require('./Home.css');

var Home = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));

    _this.renderBanner = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner-wrapper-gray' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-green' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  'We have the power to cut our financial ties to gun violence'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-btn-box-border' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-tagline' },
                    'Find sustainable, gun free mutual funds and ETFs'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-btn-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.clean,
                        bigbutton: true,
                        title: 'Get started' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Gun free funds',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'search-box-border' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-tagline-2' },
                    'Check your mutual funds for investments in gun companies'
                  ),
                  _react2.default.createElement(_components.AutocompleteSearch, null)
                )
              )
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var link = _config2.default.domain;
      var message = _config2.default.shareMessage;
      var iyvLogo = require('../../../static/images/iyv-logo-project-of-2021.jpg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        this.renderBanner(),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'title' },
            _react2.default.createElement('img', {
              src: iyvLogo,
              styleName: 'iyv-logo',
              alt: 'Invest Your Values - a project of As You Sow'
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lede' },
            _react2.default.createElement(
              'p',
              null,
              'People invest their savings in firearm manufacturers and retailers raking in billions in handgun, assault rifle, and ammunition sales. Most don\u2019t even know it. We don\u2019t need to profit from violence when we\'re investing in our retirement accounts. From non-profit As You Sow, ',
              _react2.default.createElement(
                'strong',
                null,
                'Gun Free Funds'
              ),
              ' is made for people looking to align their investments with their values by moving money out of companies that make and sell guns.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'With a ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.toolkit,
                  xstrong: true,
                  title: 'Gun free action toolkit | Gun Free Funds'
                },
                'gun free action toolkit'
              ),
              ' to answer questions like how to ask your employer to provide gun free 401(k) investment options, Gun Free Funds shows you gun investments that may be hidden inside the mutual funds you own. It\u2019s your choice - take control and make sure your investments are not profiting from \u201Cblood money.\u201D'
            )
          )
        ),
        _react2.default.createElement(_components.SocialButtons, { message: message, link: link }),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'small-title' },
            'Gun manufacturers and retailers'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'h3 narrow' },
            'If you own mutual funds or exchange-traded funds (ETFs), there\u2019s a good chance that you own shares of gun manufacturers and gun retailers profiting from the bloodshed of mass shootings and gun violence.'
          ),
          _react2.default.createElement(_components.ScreenedCompanies, null)
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement(_components.TargetDateGrid, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FamilyGrid, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(_components.AboutBanner, null)
        )
      );
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1291
// module chunks = 0